module.exports = __webpack_public_path__ + "static/media/salvation.67eb74ff.jpg";